import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6 text-muted-foreground hover:text-foreground"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#1E40AF' }}>
          Politique de Confidentialité
        </h1>

        <p className="text-muted-foreground mb-8">
          Cette politique décrit comment DevisFast collecte, utilise et protège vos données personnelles, conformément au RGPD (UE 2016/679) et à la loi Informatique et Libertés.
        </p>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">1. Responsable du traitement</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Société : ZANATTA CONSULTING (SARL)</li>
              <li>Adresse : 9 Clos de Poumarol, 31320 Aureville</li>
              <li>SIRET : 850 771 452 00024</li>
              <li>Email : support@devisfast.fr</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">2. Données collectées</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">2.1 Données d'identification</h3>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Mot de passe (chiffré, non accessible en clair)</li>
            </ul>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">2.2 Données professionnelles</h3>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Raison sociale et forme juridique</li>
              <li>SIRET, numéro de TVA</li>
              <li>Adresse professionnelle</li>
              <li>Coordonnées bancaires (IBAN/BIC) — stockées localement dans l'app</li>
              <li>Logo de l'entreprise</li>
            </ul>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">2.3 Données d'utilisation</h3>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Devis et factures créés</li>
              <li>Liste de clients</li>
              <li>Catalogue de prestations</li>
            </ul>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">2.4 Données de paiement</h3>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Données de paiement gérées directement par Stripe (DevisFast ne stocke pas vos coordonnées bancaires)</li>
              <li>Historique des transactions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">3. Finalités du traitement</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Fourniture du Service (création de devis et factures)</li>
              <li>Gestion de votre compte et de votre abonnement</li>
              <li>Envoi de vos documents à vos clients via email</li>
              <li>Envoi d'emails transactionnels (confirmation, relances, réinitialisation de mot de passe)</li>
              <li>Amélioration du Service</li>
              <li>Respect de nos obligations légales et comptables</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">4. Base légale des traitements</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Exécution du contrat : fourniture du Service souscrit</li>
              <li>Intérêt légitime : amélioration du Service, prévention de la fraude</li>
              <li>Obligation légale : conservation des données comptables et fiscales</li>
              <li>Consentement : envoi d'emails marketing (si applicable)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">5. Destinataires des données</h2>
            <p className="mb-3">Vos données peuvent être partagées avec les sous-traitants suivants :</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Render Services, Inc. — hébergement de l'application (USA, clauses contractuelles types UE)</li>
              <li>MongoDB, Inc. — hébergement de la base de données (USA, clauses contractuelles types UE)</li>
              <li>Stripe, Inc. — gestion des paiements (USA, clauses contractuelles types UE)</li>
              <li>Resend, Inc. — envoi d'emails transactionnels</li>
              <li>OVH SAS — hébergement de la messagerie professionnelle support@devisfast.fr (France, données hébergées en Europe)</li>
            </ul>
            <p className="mt-3">Vos données ne sont jamais vendues à des tiers.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">6. Durée de conservation</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Données de compte actif : durée de l'abonnement + 90 jours après résiliation</li>
              <li>Données comptables et de facturation : 10 ans (obligation légale)</li>
              <li>Données de connexion et logs : 1 an</li>
              <li>Demandes de suppression : traitées dans un délai de 30 jours</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">7. Vos droits (RGPD)</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Droit d'accès : obtenir une copie de vos données personnelles</li>
              <li>Droit de rectification : corriger vos données inexactes ou incomplètes</li>
              <li>Droit à l'effacement : demander la suppression de vos données</li>
              <li>Droit à la portabilité : recevoir vos données dans un format structuré</li>
              <li>Droit d'opposition : vous opposer au traitement de vos données</li>
              <li>Droit à la limitation : limiter le traitement de vos données</li>
            </ul>
            <p className="mt-3">Pour exercer vos droits : support@devisfast.fr</p>
            <p>Réclamation auprès de la CNIL : www.cnil.fr</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">8. Sécurité des données</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Chiffrement des mots de passe (bcrypt)</li>
              <li>Communications chiffrées via HTTPS/TLS</li>
              <li>Authentification par token JWT</li>
              <li>Accès à la base de données restreint et authentifié</li>
              <li>Hébergement sur des serveurs sécurisés</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">9. Cookies</h2>
            <p>DevisFast utilise uniquement des cookies techniques strictement nécessaires au fonctionnement du Service. Aucun cookie publicitaire ou de tracking tiers n'est utilisé.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">10. Transferts hors UE</h2>
            <p>Certains sous-traitants (Render, MongoDB, Stripe) sont établis aux États-Unis. Ces transferts sont encadrés par des clauses contractuelles types approuvées par la Commission européenne. OVH héberge les emails en Europe (France), sans transfert hors UE.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">11. Modifications</h2>
            <p>Cette politique peut être mise à jour. En cas de modification substantielle, vous serez notifié par email. Version en vigueur accessible sur : https://devisfast.fr/privacy</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">12. Contact</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Email : support@devisfast.fr</li>
              <li>Courrier : ZANATTA CONSULTING — 9 Clos de Poumarol, 31320 Aureville</li>
            </ul>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-center text-sm text-muted-foreground">
          Dernière mise à jour : 09/03/2026
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
